// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from '@/store/index'
import './assets/cb/cb-static/cb.date'

Vue.config.productionTip = false

const sprintf = require('@/assets/js/sprintf.min').sprintf
require('@/assets/js/cb.date')
Date.setDTGFormat('%Y%m%d%H%M')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js